export const ApplyCouponArr = [
  {
    path: "coupon/:id(\\d+)",
    name: "coupon",
    meta: {
      title: "优惠券"
    },
    redirect: "/apply/coupon/:id(\\d+)/ticket",
    component: () => import("@/views/sidebar/itemFrame.vue"),
    children: [
      {
        path: "ticket",
        name: "ticket",
        meta: {
          title: "优惠券管理"
        },
        component: () =>
          import("@/views/apply/comModule/coupon/ticket/index.vue")
      },
      {
        path: "optionTicket",
        name: "optionTicket",
        meta: {
          title: "添加优惠券"
        },
        component: () =>
          import("@/views/apply/comModule/coupon/ticket/adticket.vue")
      },
      {
        path: "discounts",
        name: "discounts",
        meta: {
          title: "优惠券核销"
        },
        component: () =>
          import("@/views/apply/comModule/coupon/ticket/discounts.vue")
      },
      {
        path: "grant",
        name: "grant",
        meta: {
          title: "优惠券领取记录"
        },
        component: () =>
          import("@/views/apply/comModule/coupon/ticket/grant.vue")
      }
      // {
      //   path: "order",
      //   name: "order",
      //   meta: {
      //     title: "兑换记录"
      //   },
      //   component: () =>
      //     import(
      //       "@/views/apply/comModule/integralMall/order/index.vue"
      //     )
      // }
    ]
  }
];
